export default __webpack_public_path__ + "static/media/HTML5.ff3cf75e.png";